/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';

/**
 * Internal dependencies
 */
import PageSettings from '../page-settings';

/**
 * Page keys enum
 * Centralizes page identifiers to prevent typos when referencing pages
 *
 * @enum {string}
 */
export const PAGE_KEYS = {
	WELCOME: 'welcome',
	SETTINGS: 'settings',
	ABOUT: 'about',
};

/**
 * Page configuration object
 *
 * @typedef {Object} PageConfig
 * @property {string} label - The label displayed in navigation
 * @property {Function} block - The React component to render for this page
 * @property {string} [description] - Optional description for the page header
 * @property {string} [href] - Optional external link for the page
 */

/**
 * Individual page configurations
 *
 * @type {Object<string, PageConfig>}
 */
const PAGE_CONFIGS = {
	[PAGE_KEYS.SETTINGS]: {
		label: __('Settings', 'marqueex'),
		block: PageSettings,
		description: __('Configure MarqueeX settings and integrations', 'marqueex'),
	},
};

/**
 * Get default page key
 *
 * @return {string} The default page key
 */
export const getDefaultPage = () => PAGE_KEYS.SETTINGS;

/**
 * Admin pages configuration
 *
 * Object keys serve as unique identifiers for each page and are used
 * for routing in the admin interface.
 *
 * @type {Object<string, PageConfig>}
 */
export default PAGE_CONFIGS;
